import { CheckIcon, CloseIcon, CopyIcon, DeleteIcon, EditIcon } from '@chakra-ui/icons';
import {
    Button,
    Link as ChakraLink,
    Flex,
    HStack,
    IconButton,
    Input, Select,
    Table, Tbody,
    Td,
    Text, Th, Thead, Tr,
    VStack,
    useColorModeValue,
    useDisclosure
} from '@chakra-ui/react';
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CampanhasController from "controllers/Campanhas/CampanhasController";
import FichasController from "controllers/Fichas/FichasController";
import OperacoesController from "controllers/Operacoes/OperacoesController";
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from '@chakra-ui/react'
import { DuplicateModal } from './duplicate-modal';

function AuditCadastroView() {
  const [data, setData] = useState([]);
  const [newNome, setNewNome] = useState("");
  const [newDescricao, setNewDescricao] = useState("");
  const [campanhas, setCampanhas] = useState([]);
  const [operations, setOperations] = useState([]);
  const [selectedCampanhaId, setSelectedCampanhaId] = useState("");
  const [selectedCampanha, setSelectedCampanha] = useState("");
  const [selectedOperation, setSelectedOperation] = useState(""); 
  const textColor = useColorModeValue("gray.700", "white");
  
  const fetchData = async () => {
    try {
      const response = await FichasController.ListFichas();
      setData(response);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();

    const fetchCampanhas = async () => {
      try {
        const response = await CampanhasController.ListCampaigns();
        setCampanhas(response);
      } catch (error) {
        console.error("Error fetching campanhas:", error);
      }
    };
    fetchCampanhas();

    const fetchOperations = async () => {
      try {
        const response = await OperacoesController.ListOperations();
        setOperations(response);
      } catch (error) {
        console.error("Error fetching operations:", error);
      }
    };
    fetchOperations();
  }, []);

  const addAuditCadastro = async () => {
    try {
      
        const response = await FichasController.AddFichas(newNome,selectedCampanha,selectedOperation,selectedCampanhaId)

      if (response) {
        const newData = await FichasController.ListFichas();
        setData(newData);
        setNewNome("");
        setNewDescricao("");
        setSelectedCampanha("");
        setSelectedCampanhaId("");
        setSelectedOperation("");
      } else {
        console.error("Failed to add audit:", jsonData.error);
      }
    } catch (error) {
      console.error("Error adding audit:", error);
    }
  };

  return (
    <Flex direction='column' height="100%" width="100%">
      <Card overflowX={{ sm: "scroll", xl: "hidden" }}>
        <CardHeader>
        <VStack spacing={2} align="stretch">
            <HStack spacing={2}>
              <Input placeholder="Nome" value={newNome} onChange={e => setNewNome(e.target.value)} />
              <Select placeholder="Selecionar campanha" value={selectedCampanha} onChange={e => 
              {
                 setSelectedCampanha(e.target.value);
                 console.log("id campanha", e.target.options[e.target.selectedIndex].id);
                 setSelectedCampanhaId(e.target.options[e.target.selectedIndex].id);
              }}>
                {campanhas.map(campanha => (
                  <option key={campanha.idcampanhas} value={campanha.campanha_nome} id={campanha.idcampanhas}>
                    {campanha.campanha_nome}
                  </option>
                ))}
              </Select>
              <Select placeholder="Selecionar operação" value={selectedOperation} onChange={e => setSelectedOperation(e.target.value)}>
                {operations.map(operations => (
                  <option key={operations.id} value={operations.description}>
                    {operations.description}
                  </option>
                ))}
              </Select>

              <Button colorScheme="blue" width="auto" minWidth="200px" onClick={addAuditCadastro}>Adicionar</Button>
              </HStack>
          </VStack>
        </CardHeader>
        <CardBody>
          <Table variant='simple' color={textColor}>
            <Thead>
              <Tr color='gray.400'>
                <Th>ID</Th>
                <Th>Data de Criação</Th>
                <Th>Nome</Th>
                <Th>Campanha</Th>
                <Th>Operação</Th>
                <Th>Ações</Th>
              </Tr>
            </Thead>
            <Tbody>
              {data.map((audit) => (
                <AuditRow
                  key={audit.id}
                  audit={audit}
                  setData={setData}
                  data={data}
                  fetchData={fetchData}
                />
              ))}
            </Tbody>
          </Table>
        </CardBody>
      </Card>
    </Flex>
  );
}

function AuditRow({ audit, setData, data, fetchData }) {
  const [isEditing, setIsEditing] = useState(false);
  const [editedNome, setEditedNome] = useState(audit.Nome);
  const [,setSelectedId] = useState(null);

  const editAudit = async () => {
    try {
      const response = await FichasController.PutFichas(audit.id, editedNome)
      if (response) {
        const updatedAudit = { ...audit, Nome: editedNome };
        const updatedData = data.map(d => (d.id === audit.id ? updatedAudit : d));
        setData(updatedData);
        setIsEditing(false);
      } else {
        console.error("Failed to edit audit");
      }
    } catch (error) {
      console.error("Error editing audit:", error);
    }
  };

  const deleteAudit = async () => {
    try {
      const response = await FichasController.DeleteFichas(audit.id)
      if (response) {
        await new Promise(resolve => setTimeout(resolve, 1000));
        const updatedData = data.filter(d => d.id !== audit.id);
        setData(updatedData);
      }
      else {
        console.error("Failed to delete audit");
      }
    } catch (error) {
      console.error("Error deleting audit:", error);
    }
  };

  return (
    <>
      <Tr>
      <Td>{audit.id}</Td>
      <Td>{audit.Data_Criacao}</Td>
        <Td>
          {isEditing
            ? <Input value={editedNome} onChange={e => setEditedNome(e.target.value)} />
            : <ChakraLink as={Link} to={`/admin/perguntas/${audit.id}`} color="blue.500" _hover={{ textDecoration: 'underline' }} onClick={() => setSelectedId(audit.id)}>
              {audit.Nome}
            </ChakraLink>


          }
        </Td>
        <Td>{audit.Campanha_Nome}</Td>
        <Td>{audit.Operacao_Descricao}</Td>
        <Td>
          <Flex>
          {isEditing ? (
            <>
              <IconButton
                mr={2}
                onClick={() => {
                  console.log("Save button clicked");
                  editAudit();
                  setIsEditing(false);
                }}
                icon={<CheckIcon />}
              />
              <IconButton
                mr={2}
                onClick={() => setIsEditing(false)}
                icon={<CloseIcon />}
              />
            </>
          ) : (
            <>
              <IconButton
                mr={2}
                onClick={() => {
                  console.log("Edit button clicked");
                  setIsEditing(true);
                }}
                icon={<EditIcon />}
              />
              <IconButton
                mr={2}
                onClick={deleteAudit}
                icon={<DeleteIcon />}
              />
              <DuplicateModal 
                audit={audit} 
                getData={fetchData} 
              />
            </>
          )}
          </Flex>
        </Td>
      </Tr>
      <Tr>
      </Tr>
    </>
  );
}
export default AuditCadastroView;